<template>
  <div class="eds-comp-myapplication-list">
    <div class="eds_filter">
      <div class="eds_filter_text" @click="toggleKeywordSearchMode">
        <v-icon style="line-height: 20px">search</v-icon>
        <span>{{ $t('搜索') }}</span>
      </div>
      <div class="eds_filter_text">
        <v-menu content-class="eds-list" bottom offset-y>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <span>{{ $t('状态') }}</span>
              <v-icon style="line-height: 20px">arrow_drop_down</v-icon>
            </span>
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in FLOW_State" :key="i" :class="{
              'eds-list-selected': flowStateFilterSetInfo.some(
                (t) => t.state === item.state
              ),
            }" @click="toggleFlowStateItem(item)">
              <v-list-tile-title>
                {{ $t(item.name) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div class="eds_filter_text">
        <v-menu content-class="eds-list" bottom offset-y>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <span>{{ $t('类型') }}</span>
              <v-icon style="line-height: 20px">arrow_drop_down</v-icon>
            </span>
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in FLOW_Type" :key="i" :class="{
              'eds-list-selected': flowTypeFilterSetInfo.some(
                (t) => t.type === item.type
              ),
            }" @click="toggleFlowTypeItem(item)">
              <v-list-tile-title>
                {{ $t(item.name) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="eds_filter_set_info" v-if="!!filterSetInfo || keywordSearchMode">
      <template v-if="!!filterSetInfo">
        <div class="eds_filter_set_info_detail">
          <span>{{ filterSetInfo }}</span>
        </div>
        <v-icon class="eds_filter_set_clear_icon" @click="onClearFilterSetInfo">cancel</v-icon>
      </template>
      <div v-if="keywordSearchMode" class="eds-comp-search__container">
        <eDSCompSearch style="background-color: rgb(244, 245, 249)" :initSearchInfo="keyword"
          @onSaveSearchSet="onSaveKeywordSet"></eDSCompSearch>
        <v-btn v-if="!!keyword" flat color="primary" @click="onKeywordSearch">{{ $t('搜索') }}</v-btn>
        <v-btn v-else flat color="primary" @click="onClearKeywordAndHide">{{ $t('取消') }}</v-btn>
      </div>
    </div>
    <div class="eds_no_info_outer" v-if="!applicationList || applicationList.length == 0"
      :style="{ height: noInfoOuterHeight }">
      <div class="eds_no_info_inner">
        <img src="imgs/svg/eds/no_task.svg" />
        <div>{{ noInfoTitle }}</div>
      </div>
    </div>
    <div v-for="(application, index) in applicationList" :key="index">
      <template v-if="isEDS16()">
        <EDSCompApplicationInfo16 class="eds-comp-application-info" :applicationInfo="application"
          :workflowType="FLOW_Type" />
      </template>
      <template v-else>
        <eDSCompApplicationInfo class="eds-comp-application-info" :applicationInfo="application" />
      </template>
      <v-divider></v-divider>
    </div>
    <div v-if="!isDefault" class="eds_loading_bar">
      <span>{{ loadingText }}</span>
    </div>
  </div>
</template>


<script>
import msgbus from '../msgBus'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import tools from '../util/tools'
import { FLOW_TYPE, FLOW_TYPE16, FLOW_STATE, FLOW_STATE16 } from '../config/work'
import eDSCompApplicationInfo from './eDSCompApplicationInfo'
import EDSCompApplicationInfo16 from './eDSCompApplicationInfo16.vue'
import eDSCompFilterSet from './eDSCompFilterSet'
import eDSCompSearch from '../components/eDSCompSearch'

export default {
  name: 'eDSCompMyApplicationList',
  components: {
    eDSCompApplicationInfo,
    EDSCompApplicationInfo16,
    eDSCompFilterSet,
    eDSCompSearch,
  },
  props: {
  },
  data() {
    return {
      // 过滤设置界面弹出状态
      keywordSearchMode: false,
      flowStateFilterModel: false,
      flowTypeFilterModel: false,
      // 过滤设置选择项集合
      FLOW_State: null,
      FLOW_Type: null, // 默认指向FLOW_TYPE，实际根据当前租户读取
      // 过滤设置信息
      keyword: '', // 搜索关键字
      flowStateFilterSetInfo: [],
      flowTypeFilterSetInfo: [],

      event: '',
      pageSize: 10, // 每页记录数
      flowListRecordCount: 0, // 已经加载的总记录数
      loadingText: '',
    }
  },
  watch: {
    flowStateFilterModel: function (a, b) {
      // alert('new' + a + 'old' + b)
    },
  },
  computed: {
    noInfoOuterHeight() {
      return `calc(${window.innerHeight}px - 48px - 48px` + ')'
    },
    filterSetInfo() {
      var retFilterSetInfo = ''
      for (var item of this.flowStateFilterSetInfo) {
        if (item.name != '全部') {
          retFilterSetInfo += this.$t(item.name) + this.$t('的') + ' '
        }
      }
      for (item of this.flowTypeFilterSetInfo) {
        if (item.name != '全部') {
          retFilterSetInfo += this.$t(item.name) + ' '
        }
      }
      if (retFilterSetInfo != '') {
        retFilterSetInfo = this.$t('过滤条件：') + retFilterSetInfo
      }
      return retFilterSetInfo
    },
    // 判断没有信息时的标题
    noInfoTitle() {
      return (this.flowStateFilterSetInfo &&
        this.flowStateFilterSetInfo.length > 0) ||
        (this.flowTypeFilterSetInfo && this.flowTypeFilterSetInfo.length > 0)
        ? this.$t('没有符合过滤条件的申请')
        : this.$t('没有申请')
    },
    isDefault() {
      return this.applicationList == null || this.applicationList.length == 0
    },
    applicationList() {
      return msgbus.vm.getUserFlows()
    },
    totalCount() {
      return msgbus.vm.getUserFlowTotalCount()
    },
  },
  methods: {
    isEDS16() {
      return msgbus.vm.isEDS16()
    },
    // 下拉选择流程状态
    toggleFlowStateItem(item) {
      this.flowStateFilterSetInfo = []
      this.flowStateFilterSetInfo.push(item)
      this.flowStateFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 下拉选择流程类型
    toggleFlowTypeItem(item) {
      this.flowTypeFilterSetInfo = []
      this.flowTypeFilterSetInfo.push(item)
      this.flowTypeFilterModel = false
      // 刷新信息
      this.onRefresh()
    },

    // 获取流程状态过滤信息
    getFlowStateFilterSetInfo() {
      // 单选
      let filterInfo =
        this.flowStateFilterSetInfo.length > 0
          ? this.flowStateFilterSetInfo[0].state
          : ''

      return filterInfo
    },

    // 获取流程类型过滤信息
    getFlowTypeFilterSetInfo() {
      // 单选
      let filterInfo =
        this.flowTypeFilterSetInfo.length > 0
          ? this.flowTypeFilterSetInfo[0].type
          : ''

      return filterInfo
    },
    // 刷新
    onRefresh(loaded) {
      this.flowListRecordCount = 0 // 初始加载0条记录
      msgbus.vm.setFlowListRecordCount({ value: 0 })

      // 获取当前用户提交的流程列表
      msgbus.vm
        .fetchUserFlows({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          tid: msgbus.vm.getCurrentTenantID(),
          data: this.getFetchParams(),
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.flowListRecordCount += this.pageSize
            msgbus.vm.setFlowListRecordCount({
              value: this.flowListRecordCount,
            })
            if (loaded != null) {
              loaded('done')
            }
          },
          () => {
            if (loaded != null) {
              loaded('done')
            }
          }
        )
    },
    // 翻页
    onAppend(loaded) {
      if (this.flowListRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
        msgbus.vm
          .appendUserFlows({
            authorization: {
              Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
            },
            tid: msgbus.vm.getCurrentTenantID(),
            data: this.getFetchParams(),
            vm: msgbus.vm,
          })
          .then(
            () => {
              this.flowListRecordCount += this.pageSize
              msgbus.vm.setFlowListRecordCount({
                value: this.flowListRecordCount,
              })
              if (loaded != null) {
                loaded('done')
              }
            },
            () => {
              if (loaded != null) {
                loaded('done')
              }
            }
          )
      } else {
        if (loaded != null) {
          loaded('fail')
        }
        this.loadingText = this.$t('已经到底了')
      }
    },
    // 获取查询参数
    getFetchParams() {
      if (msgbus.vm.isEDS16()) {
        let filter = {}
        let state = this.getFlowStateFilterSetInfo()
        if (state != '') {
          filter['state'] = state
        }
        let type = this.getFlowTypeFilterSetInfo()
        if (type != '') {
          filter['type'] = type
        }
        var data = {
          order: '-createdAt',
          skip: this.taskListRecordCount,
          limit: this.pageSize,
          filter: JSON.stringify(filter)
        }
      } else {
        data = {
          state: this.getFlowStateFilterSetInfo(),
          type: this.getFlowTypeFilterSetInfo(),
          order: '-createTime',
          skip: this.flowListRecordCount,
          limit: this.pageSize,
        }
      }
      return data
    },


    // 显示搜索框
    toggleKeywordSearchMode() {
      this.keywordSearchMode = !this.keywordSearchMode
      if (!this.keywordSearchMode) {
        this.keyword = ''
        this.onRefresh()
      }
    },
    // 保存搜索设置
    onSaveKeywordSet(searchSetInfo) {
      this.keyword = searchSetInfo ? searchSetInfo : ''
      if (!this.keyword) {
        // 刷新信息
        this.onRefresh()
      }
    },
    // 关键字搜索
    onKeywordSearch() {
      this.onRefresh()
    },
    onClearKeywordAndHide() {
      this.keyword = ''
      this.keywordSearchMode = false
      this.onRefresh()
    },

    // 显示流程状态过滤设置
    onFlowStateFilter() {
      this.flowStateFilterModel = true
    },
    // 保存流程状态过滤设置
    onSaveFlowStateFilterSet(filterSetInfo) {
      this.flowStateFilterSetInfo = [...filterSetInfo]
      this.flowStateFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 显示流程类型过滤设置
    onFlowTypeFilter() {
      this.flowTypeFilterModel = true
    },
    // 保存流程类型过滤设置
    onSaveFlowTypeFilterSet(filterSetInfo) {
      this.flowTypeFilterSetInfo = [...filterSetInfo]
      this.flowTypeFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 清空当前页的过滤设置信息
    onClearFilterSetInfo() {
      // this.keyword = ''
      // this.keywordSearchMode = false
      this.flowStateFilterSetInfo = []
      this.flowTypeFilterSetInfo = []
      // 刷新信息
      this.onRefresh()
    },
  },
  created() {
    console.log('调试代码')

    this.FLOW_State = msgbus.vm.isEDS16() ? FLOW_STATE16 : FLOW_STATE
    this.FLOW_Type = msgbus.vm.isEDS16() ? FLOW_TYPE16 : FLOW_TYPE // 默认指向FLOW_TYPE，实际根据当前租户读取

    // 读取流程类型
    msgbus.vm
      .fetchFlowTypes({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: msgbus.vm.getCurrentTenantID(),
        vm: msgbus.vm,
      })
      .then(
        () => {
          this.FLOW_Type = msgbus.vm.getFlowTypes()
        },
        () => { }
      )

    // 读取过滤设置信息
    this.flowStateFilterSetInfo = msgbus.vm.getFlowStateFilterSetInfo()
    this.flowTypeFilterSetInfo = msgbus.vm.getFlowTypeFilterSetInfo()

    // 读取页面加载的总记录数
    var flowListRecordCountTmp = parseInt(dbHelper.get('flowListRecordCount'))
    this.flowListRecordCount = isNaN(flowListRecordCountTmp)
      ? 0
      : flowListRecordCountTmp
    msgbus.vm.setFlowListRecordCount({ value: this.flowListRecordCount })
    if (msgbus.vm.getUserFlows().length == 0 || this.flowListRecordCount == 0) {
      // 显示信息
      this.onRefresh()
    } else {
      this.event = 'updateScrollTop'
      if (this.flowListRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
      } else {
        this.loadingText = this.$t('已经到底了')
      }
    }
  },
  mounted() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('flowListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('flowListScrollTop', 0)
        dbHelper.set('flowListRecordCount', 0)
        break
    }
    this.event = ''
  },
  updated() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('flowListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('flowListScrollTop', 0)
        dbHelper.set('flowListRecordCount', 0)
        break
    }
    this.event = ''
  },
  beforeDestroy() {
    // 保存过滤设置信息
    msgbus.vm.setFlowStateFilterSetInfo({ value: this.flowStateFilterSetInfo })
    msgbus.vm.setFlowTypeFilterSetInfo({ value: this.flowTypeFilterSetInfo })
  },
}
</script>


<style lang="scss">
.eds-comp-myapplication-list {
  .eds-comp-application-info {
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>